/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipForwardIcon16Light = forwardRef('MediaUiASkipForwardIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 2.5a.5.5 0 0 0-1 0v5.147a.989.989 0 0 0-.402-.492L3.733 2.188A1.13 1.13 0 0 0 2 3.143v9.714c0 .89.981 1.43 1.733.955l7.865-4.967A.989.989 0 0 0 12 8.353V13.5a.5.5 0 0 0 1 0v-11ZM3 3.143a.13.13 0 0 1 .2-.11L11.063 8l-7.865 4.967a.13.13 0 0 1-.199-.11V3.143Z" })));
});
